import {
  TagPassThroughOptions,
} from '@NitrexGroup/primevue/tag';
import type {
  PassThrough,
} from '@NitrexGroup/primevue/ts-helpers';

import {
  getContrastForRgbString,
} from './color.ts';

/**
 * Builds a PrmTag `pt` passthrough object that applies a semantic background color with the
 * given text color, or by default with the black or white text that contrasts more with it.
 *
 * Usage: `<PrmTag :pt="buildTagColorPassthrough(SemanticColors.critical)" />`
 */
export function buildTagColorPassthrough(backgroundColor: string, textColor?: string): PassThrough<TagPassThroughOptions> {
  return {
    root: {
      style: {
        'background-color': backgroundColor,
        'color': textColor ?? getContrastForRgbString(backgroundColor),
      },
    },
  };
}

export type TTagColorPassthrough = ReturnType<typeof buildTagColorPassthrough>;
